export default "__VITE_ASSET__Cqn$FQWp__"